import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getram(vcpu:any) {
  return axios.get(API_URL+'/v1/fw/list_ram/'+vcpu)
}
export function getramtenant(vcpu:any,tenant:any) {
    return axios.get(API_URL+'/v1/fw/list_ram/'+vcpu+'?tenant='+tenant)
  }

export function getentitlements(source:any) {
  return axios.get(API_URL+'/v1/fw/list_entitlemen?source='+source)
}
export function getentitlementstenant(tenant:any,source:any) {
  return axios.get(API_URL+'/v1/fw/list_entitlemen?tenant='+tenant+'&source='+source)
}


export function getlistDevice(SuscriptionId:any) {
  return axios.get(API_URL+'/v1/fw/list/'+SuscriptionId)
}
export function getlistDevicetenant(tenant:any, SuscriptionId:any) {
  return axios.get(API_URL+'/v1/fw/list/'+SuscriptionId+'?tenant='+tenant)
}

export function getcredentias(SuscriptionId:any,fw:any) {
  return axios.get(API_URL+'/v1/fw/password/'+SuscriptionId+'/'+fw)
}